import {
  GET_PROJECT_ALL_BRANDS_RESPONSE,
  GET_PROJECT_DAILY_STATS,
  GET_PROJECT_SOV_PER_MODEL,
  GET_PROJECT_SOV_TIME_SERIES,
  GET_PROJECT_VISIBILITY_CHART,
} from '../../query/project/stats/keys';
import { GET_KEYWORDS_DAILY_STATS_FOR_PROJECT } from '../../query/keyword/stats/keys';
import { QueryClient } from '@tanstack/react-query';
import { GET_COMMON_KEYWORDS } from '../../query/keyword/keys';
import {
  GET_DOMAINS_STATS,
  GET_DOMAINS_WITH_SOURCES_STATS,
  GET_KEY_SOURCES_STATS,
  GET_SOURCES_FOR_PROJECT,
  GET_SOURCES_STATS,
} from '../../query/monitor/data/sources/keys';
import { GET_PROJECT_MONITORS } from '../../query/monitor/keys';

export const invalidateProjectQueries = (queryClient: QueryClient, projectId: number): void => {
  console.log(`[QueryInvalidation] Invalidating queries for project ${projectId}`);

  const queries = [
    GET_PROJECT_DAILY_STATS,
    GET_KEYWORDS_DAILY_STATS_FOR_PROJECT,
    GET_COMMON_KEYWORDS,
    GET_SOURCES_FOR_PROJECT,
    GET_PROJECT_ALL_BRANDS_RESPONSE,
    GET_PROJECT_VISIBILITY_CHART,
    GET_PROJECT_SOV_TIME_SERIES,
    // Feeds the "SoV by AI Chatbots" bar chart — was missing, so the bar stayed stale on live
    // updates while the other SoV sections refreshed, leaving an inconsistent partial state.
    GET_PROJECT_SOV_PER_MODEL,
    // Sources/domains tables (Key Sources, Top Domains, sources & domain detail) — were missing, so
    // they stayed stale on live updates until a manual F5 even though the data was already collected.
    GET_KEY_SOURCES_STATS,
    GET_DOMAINS_STATS,
    GET_DOMAINS_WITH_SOURCES_STATS,
    GET_SOURCES_STATS,
  ];

  queries.forEach((queryKey) => {
    queryClient.invalidateQueries({
      predicate: (query) => query.queryKey[0] === queryKey,
      refetchType: 'active',
    });
  });

  queryClient.invalidateQueries({
    queryKey: [GET_PROJECT_MONITORS, projectId],
    refetchType: 'active',
  });
};
